const invoice = (editor) => {

    editor.BlockManager.add('invoice', {
        category: 'Built In Components',
        label: 'Invoice',
        attributes: {},
        content: `
        <div class="card">
          <div class="card-body">
            <div class="container mb-5 mt-3">
              <div class="row d-flex align-items-baseline">
                <div class="col-xl-9">
                  <p class="text-secondary">Invoice >> <strong>ID: #123-123</strong></p>
                </div>
                
                <hr>
              </div>

              <div class="container">
                <div class="col-md-12">
                  <div class="text-center">
                    <i class="bi-badge-tm ms-0"></i>
                    <p class="pt-0">LOGO</p>
                  </div>

                </div>


                <div class="row">
                  <div class="col-xl-8">
                    <ul class="list-unstyled">
                      <li class="text-muted">To: <span class="text-primary">John Lorem</span></li>
                      <li class="text-muted">Street, City</li>
                      <li class="text-muted">State, Country</li>
                      <li class="text-muted"><i class="bi-telephone"></i> 123-456-789</li>
                    </ul>
                  </div>
                  <div class="col-xl-4">
                    <p class="text-muted">Invoice</p>
                    <ul class="list-unstyled">
                      <li class="text-muted"><i class="bi-circle-fill" class="text-primary"></i> <span
                          class="fw-bold">ID:</span>#123-456</li>
                      <li class="text-muted"><i class="bi-circle-fill" class="text-primary"></i> <span
                          class="fw-bold">Creation Date: </span>Jun 23,2021</li>
                      <li class="text-muted"><i class="bi-circle-fill" class="text-primary"></i> <span
                          class="me-1 fw-bold">Status:</span><span class="badge bg-success text-black fw-bold">
                          Paid</span></li>
                    </ul>
                  </div>
                </div>

                <div class="row my-2 mx-1 justify-content-center">
                  <table class="table table-striped table-borderless">
                    <thead class="text-white bg-dark">
                      <tr>
                        <th scope="col"><strong>#</strong></th>
                        <th scope="col"><strong>Description</strong></th>
                        <th scope="col"><strong>Qty</strong></th>
                        <th scope="col"><strong>Unit Price</strong></th>
                        <th scope="col"><strong>Amount</strong></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row"><strong>1</strong></th>
                        <td><span>Pro Package</span></td>
                        <td><span>4</span></td>
                        <td><span>$200</span></td>
                        <td><span>$800</span></td>
                      </tr>
                      <tr>
                        <th scope="row"><strong>2</strong></th>
                        <td><span>Web hosting</span></td>
                        <td><span>1</span></td>
                        <td><span>$10</span></td>
                        <td><span>$10</span></td>
                      </tr>
                      <tr>
                        <th scope="row"><strong>3</strong></th>
                        <td><span>Consulting</span></td>
                        <td><span>1 year</span></td>
                        <td><span>$300</span></td>
                        <td><span>$300</span></td>
                      </tr>
                    </tbody>

                  </table>
                </div>
                <div class="row">
                  <div class="col-xl-8">
                    <p class="ms-3">Add additional notes and payment information</p>

                  </div>
                  <div class="col-xl-3">
                    <ul class="list-unstyled">
                      <li class="text-muted ms-3"><span class="text-black me-4">SubTotal</span>$1110</li>
                      <li class="text-muted ms-3 mt-2"><span class="text-black me-4">Tax(15%)</span>$111</li>
                    </ul>
                    <p class="text-black float-start"><span class="text-black me-3"> Total Amount</span><span
                        >$1221</span></p>
                  </div>
                </div>
                <hr>
                <div class="row">
                  <div class="col-xl-10">
                    <p>Thank you for your purchase</p>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        `
    })
};

export default invoice;